import _ from 'lodash';
import React from 'react';
import thunk from 'redux-thunk';

import moment from 'moment';

import MiniTimer from 'minitimer';

import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, combineReducers } from 'redux';

import { makeRecorderMiddleware, Recorder } from './src/Recorder.js';

import translator from 'translate-react';
translator.learn("de", require('./translation/de.js'));
translator.learn("en", require('./translation/en.js'));

import {
    calendarReducer,
    CalendarControl
} from './components/Calendar';

import {
    ReduxPeopleSelect,
    peopleSelectReducer,
} from './components/PeopleSelect';

import DesktopApp, { desktopReducer } from './DesktopApp';



export var widgetClasses = {
    'calendar': require('./components/ReduxCalendar.js').default,
    'calendar-display': require('./components/CalendarDisplay').default,
    'calendar-control': CalendarControl,
    'locale-control': require('./components/LocaleControl').default,
    'peopleselect': ReduxPeopleSelect,
    'people-display': require('./components/PeopleDisplay').default,
    'desktop': DesktopApp,
};

import {
    START_RENDER, STOP_RENDER,
    SET_LANGUAGE, SET_CURRENCY,
    setLanguage
} from './actions';

/**
 * Reducer to manage the application localization.
 * BEWARE: This function has side effects (moment/Translator)
 */
let localeReducer = function(state = {language: "de", currency: 'EUR'}, action) {
    switch ( action.type ) {
        case SET_LANGUAGE:
            moment.locale(action.language);
            translator.setLanguage(action.language);
            state = { ...state, language: action.language };
            break;

        case SET_CURRENCY:
            translator.setCurrency(action.currency);
            state = { ...state, currency: action.currency };
            break;
    }
    return state;
}


/**
 * Application class to manage the whole IBE and it's widgets.
 */
export default class IBE {
    constructor(options) {
        options = {
            language: 'de',
            ... ( options || {} )
        };

        if ( process.env.NODE_ENV === 'development' ) {
            console.log("Tramino IBE: DEVELOPMENT Build");
        } else {
            console.log("Tramino IBE: PRODUCTION Build");
        }


        let enhancer;
        if ( process.env.NODE_ENV === 'development' && options.recorder ) {
            this.recorder = new Recorder();
            enhancer = applyMiddleware(thunk, makeRecorderMiddleware(this.recorder.store));
        } else {
            enhancer = applyMiddleware(thunk);
        }

        this.store = createStore(
            combineReducers({
                locale: localeReducer,
                calendar: calendarReducer,
                people: peopleSelectReducer,
                desktop: desktopReducer,
                app: options.appReducer || ((state={}, action) => state),
                render: (state=true, action) => {
                    if ( action.type === START_RENDER ) return true;
                    if ( action.type === STOP_RENDER  ) return false;
                    return state;
                },
                debug: (state={}, action) => {
                    console.log("%cACTION%c %o", "font-weight: bold; color: pink", "font-weight: normal", action);
                    return state;
                },
            }),
            enhancer
        );

        if (process.env.NODE_ENV === 'development' && options.recorder) {
            this.recorder.app_dispatch = this.store.dispatch;
        }

        console.log("[ibe] Setting locale to", options.language);
        this.store.dispatch(setLanguage(options.language));
    }

    /**
     * Register a widget.
     * They're rendered on the next store change or render() call.
     *
     * @param {String} type      See widgetClasses for available widgets
     * @param {String} id        ID of element in DOM
     * @param {Object?} options  Additional arguments for the component
     */
    widget(type, id, options={}) {
        let node = document.getElementById(id);
        if ( !node ) {
            throw new Error("Missing DOM element with id " + id);
        }

        let Component = widgetClasses[type];
        if ( !Component ) {
            throw new Error("Unknown widget type: " + type);
        }

        // @todo This is bad practice, use connect() with all components
        let state = this.store.getState();

        console.log("widget", Component, "=>", node);

        render(
            <Provider store={this.store}>
                <Component state={state} {...options} />
            </Provider>,
            node
        );
    }

    /**
     * Set the locale (translation/localisation) for the whole application.
     */
    set_locale(language) {
        this.store.dispatch(setLanguage(language));
    }

}




/** WEBPACK FOOTER **
 ** ../ibe/ibe.js
 **/